import { BlurEvent, LookupModelSelectionEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutManualOpenItem } from "./autogen/AutogenLayoutManualOpenItem";
import { Currency, CurrencySettings, CurrencyUtil } from "@mcleod/core";

export class ManualOpenItem extends AutogenLayoutManualOpenItem {
    onLoad(): void | Promise<void> {
        CurrencyUtil.configureCurrencySelector(this.textboxCurrencyType);
        return super.onLoad();
    }

    textboxCustomerIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.selection && CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            const selectedRow = event.selection;
            const currencyCode = selectedRow.getString("currency_type", CurrencySettings.getTransactionalCurrency());
            const shipDate = this.mainDataSource.activeRow?.getDate("ship_date", new Date());

            const amount = this.mainDataSource.activeRow?.getCurrency("amount", new Currency(0));
            amount.setCurrencyCode(currencyCode);
            amount.setConversionDate(shipDate || new Date());
            this.mainDataSource.activeRow?.updateCurrency("amount", amount);
            this.mainDataSource.activeRow?.setValueAndLookupModelData("amount_c", currencyCode, { currency_type_id: currencyCode });
        }
    }

    textboxShipDateOnBlur(event: BlurEvent) {
        const textboxShipDate = event.target as Textbox;
        const newShipDate = textboxShipDate.getDataValue() as Date | null;
        if (newShipDate) {
            if (this.mainDataSource.activeRow?.isNull("bill_date")) {
                this.mainDataSource.activeRow?.set("bill_date", newShipDate);
            }
            if (this.mainDataSource.activeRow?.isNull("gl_date")) {
                this.mainDataSource.activeRow?.set("gl_date", newShipDate);
            }
            if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
                const amount = this.mainDataSource.activeRow?.getCurrency("amount", new Currency(0));
                amount.setConversionDate(newShipDate);
                this.mainDataSource.activeRow?.updateCurrency("amount", amount);
            }
        }
    }

    textboxCurrencyTypeOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.selection && CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            const selectedRow = event.selection;
            const currencyCode = selectedRow.getString("currency_type_id", CurrencySettings.getTransactionalCurrency());
            const amount = this.mainDataSource.activeRow?.getCurrency("amount", new Currency(0));
            amount.setCurrencyCode(currencyCode);
            this.mainDataSource.activeRow?.updateCurrency("amount", amount);
        }
    }
}
